module.exports = __webpack_public_path__ + "media/components/country-flag/static/om-079364aa7b7a31bd4f1dd43edfffff61.svg";